module.exports = __webpack_public_path__ + "img/icon-sierras-le_mclaren.02a16e7.png";